import interior1 from "../img/interior/interior1.jpg";
import interior2 from "../img/interior/interior2.jpg";
import interior3 from "../img/interior/interior3.jpg";
import interior4 from "../img/interior/interior4.jpg";
import interior5 from "../img/interior/interior5.jpg";
import interior6 from "../img/interior/interior6.jpg";
import interior7 from "../img/interior/interior7.jpg";
import metal1 from "../img/metal/metal1.JPG";
import metal2 from "../img/metal/metal2.JPG";
import metal3 from "../img/metal/metal3.JPG";
import metal4 from "../img/metal/metal4.JPG";
import metal5 from "../img/metal/metal5.jpg";
import metal6 from "../img/metal/metal6.JPG";
import gelaender1 from "../img/gelaendere/gelaender1.jpg";
import gelaender2 from "../img/gelaendere/gelaender2.JPG";
import gelaender3 from "../img/gelaendere/gelaender3.jpg";
import gelaender4 from "../img/gelaendere/gelaender4.JPG";
import gelaender5 from "../img/gelaendere/gelaender5.JPG";
import montering1 from "../img/montering/montering1.jpg";
import montering2 from "../img/montering/montering2.jpg";
import montering3 from "../img/montering/montering3.jpg";

export const interiorImages = [
  { url: interior1 },
  { url: interior2 },
  { url: interior3 },
  { url: interior4 },
  { url: interior5 },
  { url: interior6 },
  { url: interior7 },
];

export const metalImages = [
  { url: metal1 },
  { url: metal2 },
  { url: metal3 },
  { url: metal4 },
  { url: metal5 },
  { url: metal6 },
];

export const gelaenderImages = [
  { url: gelaender1 },
  { url: gelaender2 },
  { url: gelaender3 },
  { url: gelaender4 },
  { url: gelaender5 },
];

export const monteringImages = [
  { url: montering1 },
  { url: montering2 },
  { url: montering3 },
];
